// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { SafetyDriverAnnotationsAreaId } from './SafetyDriverAnnotationsAreaId'
import { SafetyDriverAnnotationsAreaNavigation } from './SafetyDriverAnnotationsAreaNavigation'
import { SafetyDriverAnnotationsAreaRoutes } from './SafetyDriverAnnotationsAreaRoutes'

const LazySafetyDriverAnnotationsComponent = lazy(
  () => import('./SafetyDriverAnnotationsArea'),
)

const SafetyDriverAnnotationsComponent = () => (
  <SuspenseLoadingWrapper>
    <LazySafetyDriverAnnotationsComponent />
  </SuspenseLoadingWrapper>
)

export const SafetyDriverAnnotationsArea = {
  id: SafetyDriverAnnotationsAreaId,
  requiredRight: BoumRight.SAFETY_DRIVER_ANNOTATION_CRUD,
  NavigationComponent: SafetyDriverAnnotationsAreaNavigation,
  route: {
    path: SafetyDriverAnnotationsAreaRoutes.route,
    component: SafetyDriverAnnotationsComponent,
  },
}
